import { GeoPoint, PreviewComponentProps } from "@camberi/firecms";
import { ReactElement } from "react";

export function GeopointPreview(value: PreviewComponentProps<any>): ReactElement {
    return value ? <div>Latitude: {value.value._lat.toString()}, Longitude: {value.value._long.toString()}</div> : <div></div>
} 